import React, { useEffect, useState } from 'react';
import {
  NavHeader,
  Bars,
  Nav,
  NavLink,
  NavMenu,
  MediaMenu,
  MediaSubMenu,
} from './style';
import data from '../../data/js/navJs.js';

const Header = () => {
  const [isResponsive, setResponsive] = useState(false);
  const [largeHeader, setLargeHeader] = useState(true);
  const isBrowser = typeof window !== `undefined`;
  const onScolling = () => {
    // console.log(isBrowser);
    if (isBrowser) {
      // console.log(window.scrollY, window.scrollX);
      if (window.scrollY >= 50) {
        setLargeHeader(false);
      } else {
        setLargeHeader(true);
      }
    }
  };
  useEffect(() => {
    window.onscroll = function () {
      onScolling();
    };
  });
  return (
    <Nav>
      <NavHeader largeHeader={largeHeader}>
        <NavLink to="/">Amit </NavLink>
      </NavHeader>

      <Bars
        onClick={() => {
          setResponsive(!isResponsive);
        }}
      />

      <NavMenu>
        {data.map((item, index) => (
          <MediaSubMenu key={index}>
            <NavLink to={item.link} key={index}>
              {item.name}
            </NavLink>
          </MediaSubMenu>
        ))}
      </NavMenu>
      {isResponsive && (
        <MediaMenu>
          {data.map((item, index) => (
            <>
              <MediaSubMenu key={index}>
                <NavLink to={item.link} key={index}>
                  {item.name}
                </NavLink>
              </MediaSubMenu>
            </>
          ))}
        </MediaMenu>
      )}
    </Nav>
  );
};

export default Header;
